export const SOUTH_STATES = ['AL', 'CA', 'FL', 'GA', 'LA', 'MS', 'SC', 'TX'];

export const GAIG_CATEGORIES = [
  {
    category: 'Trailer Construction',
    assetClass: 'Z1',
  },
  {
    category: 'Sawmill',
    assetClass: 'Q1',
  },
  {
    category: 'Compact Construction',
    assetClass: 'G2',
  },
  {
    category: 'Heavy Construction',
    assetClass: 'G1',
  },
  {
    category: 'Lifts',
    assetClass: 'G3',
  },
  {
    category: 'Portable Construction',
    assetClass: 'I4',
  },
  {
    category: 'Utility Construction',
    assetClass: 'G6',
  },
  {
    category: 'Class 1-2',
    assetClass: 'V1',
  },
  {
    category: 'Class 3-5',
    assetClass: 'V2',
  },
  {
    category: 'Class 6-7',
    assetClass: 'V4',
  },
  {
    category: 'Class 8',
    assetClass: 'V6',
  },
  {
    category: 'Utility Trailer',
    assetClass: 'V7',
  },
  {
    category: 'Trailer',
    assetClass: 'V8',
  },
  {
    category: 'Semi-Trailer',
    assetClass: 'V9',
  },
];
